"use client"

import { motion } from "framer-motion"
import { Clock, Truck, Heart } from "lucide-react"

const features = [
  {
    icon: Clock,
    title: "Original Recipes",
    description: "Our unique meals are freshly prepared with the finest of ingredients.",
  },
  {
    icon: Truck,
    title: "Fast Delivery",
    description: "Get your meals to your doorstep within minutes. Delivery around Lagos, Mon-Sun.",
  },
  {
    icon: Heart,
    title: "Friendly Service",
    description: "We ensure each experience is unique and maximum satisfaction guaranteed.",
  },
]

export function FeaturesSection() {
  return (
    <section className="py-16 md:py-24 bg-background">
      <div className="container mx-auto px-4">
        <div className="grid gap-8 md:grid-cols-3">
          {features.map((feature, index) => {
            const Icon = feature.icon
            return (
              <motion.div
                key={feature.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="text-center"
              >
                <div className="mb-4 inline-flex items-center justify-center rounded-full bg-gradient-to-r from-orange-500/10 to-amber-500/10 p-4">
                  <Icon className="h-8 w-8 text-orange-500" />
                </div>
                <h3 className="text-xl font-bold mb-2">{feature.title}</h3>
                <p className="text-muted-foreground">{feature.description}</p>
              </motion.div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

